import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "Pagination" }
const _hoisted_2 = { class: "Pagination__Current" }
const _hoisted_3 = { class: "Pagination__Current__Mask" }
const _hoisted_4 = {
  class: "Pagination__Current__Inner",
  ref: "list"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", { class: "Pagination__Current__Point" }, ".", -1)
const _hoisted_6 = { class: "Pagination__Total" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.total + 1), (n, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'index-' + index
            }, _toDisplayString(index), 1))
          }), 128))
        ], 512)
      ]),
      _hoisted_5
    ]),
    _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.total) + ".", 1)
  ]))
}